class ProductShippingBar extends HTMLElement {
  connectedCallback() {
    const dateEl = this.querySelector('[data-shipping-date]');
    if (!dateEl) return;

    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);

    dateEl.textContent = tomorrow.toLocaleDateString('pt-PT', {
      timeZone: 'Europe/Lisbon',
      day: 'numeric',
      month: 'numeric',
    });
  }
}

if (!customElements.get('product-shipping-bar')) {
  customElements.define('product-shipping-bar', ProductShippingBar);
}
